import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import {getStreetViewPreview} from "../../api/google"
import CreateAudit from "../../component/audit/createAudit.js";
import crypto from "crypto"

import {getBase64} from '../../utils/tools';

class CreateAuditcon extends React.Component{
  constructor(props) {
    super(props);

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileRemove = this.handleFileRemove.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.completeForm = this.completeForm.bind(this);
    this.handleAuditNumChange = this.handleAuditNumChange.bind(this);

    this.state = {
        formData: {
            date: "",
            address: "",
            latitude: "",
            longitude:"",
            dateLimit: "",
            qualifications: [],
            mentions: [],
            reference: "",
            lot: "",
            client: "",
            company: {
              name: "",
              reference: "",
              manager: "",
              phone: "",
              email: "",
              siret: "",
              department: ""
            },
            summary: {},
            preview: {},
            type: ""
        },
        siretError: false,
        auditNum: "",
        submitted: false
    };

  }

  componentWillMount() {
      /* import les organisations */
      this.props.getAuditTypesAction()
      /* import les qualifications */
      this.props.getQualificationsAction()
      /* import les mentions */
      this.props.getMentionsAction()
  }

    completeForm(data){
        const { formData } = this.state;
        formData.company["name"] = data.denomination;
        //formData.company["customer_address"] = data.adresse + ", " + data.codePostal + " " + data.ville;
        formData.company["siret"] = data.siret;
        formData.company["department"] = data.codePostal.substr(0,2);
        this.setState({ formData,siretError: false });
    }

  handleDateChange = id => date => {
    const { formData } = this.state;
    formData[id] = date ? date.format("YYYY/MM/DD HH:mm:ss") : "";
    this.setState({ formData });
  };

  handleFileChange(event) {
    const target = event.target;
    if(target.files[0].type === "application/pdf" || target.files[0].type === "image/jpg" || target.files[0].type === "image/jpeg" || target.files[0].type=== "image/png") {
      getBase64(target.files[0]).then(res => {
        let formData = Object.assign({}, this.state.formData);

        formData[target.name] = {path: res, title: target.files[0].name};
        this.setState({formData: formData});
      });
    } else {
      this.props.displaySnackbar("error", "Format non pris en charge");
    }
  }

    handleAuditNumChange(event){
        var regex = /([0-9]*)-([0-9]*)-([0-9]*)-EETI-([0-9]*)/gm;
        var match = regex.exec(event.target.value);
        if(match && match.length === 5){
            const { formData } = this.state;
            formData["lot"] = match[1];
            formData["reference"] = match[2];
            formData.company["reference"] = match[3];
            formData.company["department"] = match[4];

            this.setState({
                auditNum: event.target.value,
                formData
            })
        }else{
            this.setState({auditNum: event.target.value})
        }
    }

  handleFileRemove(id) {
    let formData = Object.assign({}, this.state.formData);
    formData[id] = {};
    this.props.closeConfirmation();
    this.setState({formData: formData});
  }

  handleInputChange(event, parent) {
      console.log(event.target.name, event.target.value)
    const { formData } = this.state;
    if(parent && typeof(parent) === "string") {
        if(event.target.name === "reference_company"){
            formData[parent]["reference"] = event.target.value;
        }else{
            formData[parent][event.target.name] = event.target.value;
        }
    }else if(event.target.name === "type"){
        formData[event.target.name] = event.target.value;
        formData["qualifications"] = [];
        formData["mentions"] = [];
    }else {
          formData[event.target.name] = event.target.value;
      }

    /* Si le champs longitude ou latitude est modifié alors on change la preview */
    if((event.target.name === "longitude" || event.target.name === "latitude")) {
      if (this.state.formData.longitude && this.state.formData.latitude) {
        getStreetViewPreview(this.state.formData.longitude, this.state.formData.latitude).then(res=>{
          let formData = Object.assign({}, this.state.formData);
          formData.preview = {path: res, title: "preview_"+crypto.randomBytes(10).toString('hex')};
          this.setState({formData: formData});
        })
      }
    }

    this.setState({ formData });
  }

  handleFormSubmit(e){
    e.preventDefault();
    if(this.state.formData.company.siret !== "" && !this.state.submitted){
        this.setState({ submitted: true, siretError: false }, () => {
            this.props.createAuditAction(this.state.formData).then(res => {

                this.setState({
                    submitted: false
                }, () => {
                    this.props.history.replace('/audits/' + res.id)
                })
            }).catch(err => {
                this.setState({
                    submitted: false
                })
            })
        })
    }else{
        this.setState({
            submitted: false,
            siretError: true
        })
    }
  }

  render(){
    return <CreateAudit
        siretError={this.state.siretError}
        handleAuditNumChange={this.handleAuditNumChange}
        auditNum={this.state.auditNum}
        completeForm={this.completeForm}
      formData={this.state.formData}
      submitted={this.state.submitted}
      handleFormSubmit={this.handleFormSubmit}
      handleInputChange={this.handleInputChange}
      handleDateChange={this.handleDateChange}
      handleSelectChange={this.handleSelectChange}
      handleFileChange={this.handleFileChange}
      user={this.props.user}
      listOfAuditTypes={this.props.listOfAuditTypes}
      listOfQualifications={this.props.listOfQualifications}
      listOfMentions={this.props.listOfMentions}
      displayConfirmation={this.props.displayConfirmation}
      handleFileRemove={this.handleFileRemove}
    ></CreateAudit>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(CreateAuditcon);



// WEBPACK FOOTER //
// ./src/container/audit/createAudit-container.js